import { Spacer } from 'foundations-components/components/Spacer';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { StartsAtMicroCopy } from '../../../../components/merch-card/price-display/PriceStyledComponents';
import { useListPrice } from '../../../../hooks/useBulkPurchaseOptions';
import { useAppSelector } from '../../../../reducers';
import { isUngatedForSlashingPricesSelector } from '../../../../selectors/GatingSelectors';
import { SingleSkeletonLoader } from '../../../components/SingleSkeletonLoader';
import { usePerMonthPriceForTerm } from '../../../hooks/pricing/useGrowthPurchaseOptions';
import { isAvailableCurrencyCode } from '../../../utils/typeguards';
import { useQueryParamTerm } from '../../../utils/urls/appQueryParamUtils';
import { CrossedOutListPrice } from '../../CrossedOutListPrice';
import { PriceByProductApiName } from '../../PriceByProductApiName';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MerchCardPrice = ({
  productApiName,
  showPerMonthPerSeat = false
}) => {
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const {
    discount,
    resolvedTerm,
    loading: priceLoading,
    error: priceError,
    price: monthlyDiscountedPrice,
    currencyCode
  } = usePerMonthPriceForTerm({
    productApiName,
    term: queryParamTerm
  });
  const isUngatedForSlashingPrices = useAppSelector(isUngatedForSlashingPricesSelector);
  const termForBulkPurchaseOptions = queryParamTerm === 'ANNUAL' ? 'annual' : 'monthly';
  const {
    monthlyListPrice,
    loading: listPriceLoading
  } = useListPrice({
    apiName: productApiName,
    queryParamTerm: termForBulkPurchaseOptions
  });
  if (priceLoading || listPriceLoading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 40,
      width: 175
    });
  }
  if (priceError) {
    return /*#__PURE__*/_jsx(View, {
      blockSize: "40px",
      inlineSize: "175px"
    });
  }
  const hasDiscount = discount && discount > 0 || monthlyListPrice && monthlyDiscountedPrice && monthlyListPrice > monthlyDiscountedPrice;
  const isAnnualPaymentTerm = resolvedTerm === 'ANNUAL';
  const showDiscountedCopy = hasDiscount || isAnnualPaymentTerm;
  const shouldShowStrikethroughPrice = isUngatedForSlashingPrices && showDiscountedCopy && monthlyListPrice && monthlyDiscountedPrice && monthlyListPrice > monthlyDiscountedPrice && isAvailableCurrencyCode(currencyCode);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showDiscountedCopy ? StartsAtMicroCopy : /*#__PURE__*/_jsx(Spacer, {
      space: "600"
    }), /*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "heading-400",
      children: /*#__PURE__*/_jsx(PriceByProductApiName, {
        productApiName: productApiName,
        showPerMonthPerSeat: showPerMonthPerSeat
      })
    }), shouldShowStrikethroughPrice && /*#__PURE__*/_jsx(CrossedOutListPrice, {
      listPrice: monthlyListPrice,
      currencyCode: currencyCode,
      productApiName: productApiName,
      showPerMonthPerSeat: showPerMonthPerSeat
    })]
  });
};